import React from 'react';
import { CloudOff, Cloud } from 'lucide-react';
import { useNetworkStatus } from '../hooks/useNetworkStatus';

const NetworkIndicator = () => {
  const isOnline = useNetworkStatus();

  if (isOnline) {
    return null; // We tonen niets als we online zijn, houdt de UI clean
  }

  return (
    <div className="fixed top-0 left-0 w-full bg-slate-800 text-slate-200 text-xs py-2 px-4 flex items-center justify-center space-x-2 z-50 shadow-md">
      <CloudOff size={16} className="text-orange-400" />
      <span>Offline modus actief. Workouts worden lokaal opgeslagen.</span>
    </div>
  );
};

export default NetworkIndicator;
